import { cn } from "./utils";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

const inputVariants = cva(
    "flex w-full rounded-md border border-slate-300 bg-white px-3 py-2 text-sm ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-slate-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-indigo-300 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 dark:border-slate-500 dark:bg-slate-900 dark:text-slate-100 dark:ring-offset-slate-900 dark:placeholder:text-slate-400 aria-invalid:border-destructive aria-invalid:ring-destructive/20",
    {
        variants: {
            inputSize: {
                xs: "h-12",
                sm: "h-11",
                md: "h-12",
            },
        },
        defaultVariants: {
            inputSize: "md",
        },
    }
);

export const inputStyle = inputVariants({ inputSize: "md" });

export interface InputProps
    extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "size">, VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, type, inputSize, ...props }, ref) => {
    return (
        <input
            type={type}
            className={cn(inputVariants({ inputSize }), className, type === "time" ? "pr-5 inline" : "")}
            ref={ref}
            {...props}
        />
    );
});
Input.displayName = "Input";

export { Input, inputVariants };
